module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      'background': _vm.ctrl.bgClr
    })
  }, [_c('div', {
    ref: "idCaptPanel",
    attrs: {
      "id": "idCaptPanel"
    },
    on: {
      "mouseover": _vm.onCaptMouseOver,
      "mouseout": _vm.onCaptMouseOut,
      "click": _vm.onCSClick
    }
  }, [_c('div', {
    ref: "idCapt",
    attrs: {
      "id": "idCapt",
      "title": _vm.captTitle
    }
  }, [_vm._v(_vm._s(_vm.captCont))]), _vm._v(" "), _c('div', {
    ref: "idCaptArr",
    attrs: {
      "id": "idCaptArr"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "3px"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "idItemPanel",
    attrs: {
      "id": "idItemPanel"
    },
    on: {
      "mouseover": _vm.onItemMouseOver,
      "mouseout": _vm.onItemMouseOut
    }
  }, [_c('div', {
    ref: "idListPanel",
    staticStyle: {
      "overflow-y": "auto",
      "border": "0px solid red"
    },
    style: ({
      'background': _vm.ctrl.bgClr
    }),
    attrs: {
      "id": "idListPanel"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65018415","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/cf/cselect.vue
// module id = 779
// module chunks = 1